<h2 mat-dialog-title>{{ 'DIALOG.CREATE_KONTROLLTERMIN' | translate }}</h2>
<mat-dialog-content class="mat-typography">
  <form [formGroup]="form" class="dialog-form">
    <!-- Kunde -->
    <div class="form-group">
      <label class="form-label" for="kunde_id">{{ 'HEADER_INFO.CLIENT' | translate }} *</label>
      <select
        class="form-control bg-white border border-gray-300 text-gray-900 text-sm rounded-lg focus:ring-blue-500 focus:border-blue-500 block w-full p-2.5"
        id="kunde_id"
        formControlName="kunde_id"
        required>
        <option value="">{{ 'APPOINTMENT_EDIT.SELECT_KUNDE' | translate }}</option>
        <option *ngFor="let kunde of activeKunden" [value]="kunde.uuid">
          {{ kunde.suchbegriff }}
        </option>
      </select>
      <div *ngIf="form.get('kunde_id')?.hasError('required') && form.get('kunde_id')?.touched" class="text-red-500 text-sm mt-1">
        {{ 'DIALOG.CLIENT_REQUIRED' | translate }}
      </div>
    </div>

    <!-- Standort -->
    <div class="form-group">
      <label class="form-label" for="standort_id">{{ 'HEADER_INFO.LOCATION' | translate }} *</label>
      <select
        class="form-control bg-white border border-gray-300 text-gray-900 text-sm rounded-lg focus:ring-blue-500 focus:border-blue-500 block w-full p-2.5"
        [class.bg-gray-100]="!form.get('kunde_id')?.value"
        [class.cursor-not-allowed]="!form.get('kunde_id')?.value"
        id="standort_id"
        formControlName="standort_id"
        [disabled]="!form.get('kunde_id')?.value"
        required>
        <option value="">{{ 'APPOINTMENT_EDIT.SELECT_STANDORT' | translate }}</option>
        <option *ngFor="let standort of filteredStandorte" [value]="standort.id">
          {{ standort.name }}
        </option>
      </select>
      <div *ngIf="form.get('standort_id')?.hasError('required') && form.get('standort_id')?.touched" class="text-red-500 text-sm mt-1">
        {{ 'DIALOG.STANDORT_REQUIRED' | translate }}
      </div>
      <div *ngIf="!form.get('kunde_id')?.value" class="text-gray-500 text-sm mt-1">
        {{ 'DIALOG.SELECT_FIRST_CLIENT' | translate }}
      </div>
    </div>

    <!-- Techniker -->
    <div class="form-group">
      <label class="form-label" for="techniker_id">{{ 'HEADER_INFO.TECHNICIAN' | translate }} *</label>
      <select
        class="form-control bg-white border border-gray-300 text-gray-900 text-sm rounded-lg focus:ring-blue-500 focus:border-blue-500 block w-full p-2.5"
        id="techniker_id"
        formControlName="techniker_id"
        required>
        <option value="">{{ 'APPOINTMENT_EDIT.SELECT_TECHNIKER' | translate }}</option>
        <option *ngFor="let tech of techniker" [value]="tech.id">
          {{ getTechnikerName(tech) }}
        </option>
      </select>
      <div *ngIf="form.get('techniker_id')?.hasError('required') && form.get('techniker_id')?.touched" class="text-red-500 text-sm mt-1">
        {{ 'DIALOG.TECHNICIAN_REQUIRED' | translate }}
      </div>
    </div>

    <!-- Durchführungsmonat -->
    <div class="form-group">
      <label class="form-label" for="durchfuehrungsmonat">{{ 'DIALOG.EXECUTION_MONTH' | translate }} *</label>
      <select
        class="form-control bg-white border border-gray-300 text-gray-900 text-sm rounded-lg focus:ring-blue-500 focus:border-blue-500 block w-full p-2.5"
        id="durchfuehrungsmonat"
        formControlName="durchfuehrungsmonat"
        required>
        <option value="">{{ 'APPOINTMENT_EDIT.SELECT_MONAT' | translate }}</option>
        <option *ngFor="let monthOption of availableMonths" [value]="monthOption.value">
          {{ monthOption.label }}
        </option>
      </select>
      <div *ngIf="form.get('durchfuehrungsmonat')?.hasError('required') && form.get('durchfuehrungsmonat')?.touched" class="text-red-500 text-sm mt-1">
        {{ 'DIALOG.EXECUTION_MONTH_REQUIRED' | translate }}
      </div>
    </div>
  </form>
</mat-dialog-content>
<mat-dialog-actions align="end" class="dialog-actions">
  <button mat-button (click)="onCancel()" class="mr-4">{{ 'COMMON.CANCEL' | translate }}</button>
  <button mat-button (click)="onSubmit()" [disabled]="loading || !form.valid" color="primary" class="mr-4">
    <span *ngIf="loading">{{ 'DIALOG.CREATING' | translate }}</span>
    <span *ngIf="!loading">{{ 'DIALOG.CREATE' | translate }}</span>
  </button>
</mat-dialog-actions>

